import { render, staticRenderFns } from "./bModal.vue?vue&type=template&id=7db74710&"
import script from "./bModal.vue?vue&type=script&lang=js&"
export * from "./bModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports